import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { useAuth } from "../lib/auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { refresh } = useAuth();
  const processed = useRef(false);

  // Synchronously set the processed flag at module level to survive StrictMode double-render
  if (typeof window !== "undefined" && !processed.current) {
    processed.current = true;
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const sessionId = params.get("session_id");
    const next = new URLSearchParams(location.search).get("next") || "/try";

    if (sessionId) {
      axios
        .post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
        .then(async () => {
          // Wipe the hash so a refresh doesn't reprocess it
          window.history.replaceState(null, "", window.location.pathname);
          await refresh();
          navigate(next, { replace: true });
        })
        .catch(() => {
          navigate("/login?error=oauth", { replace: true });
        });
    } else {
      // Nothing to do — bounce back to login
      setTimeout(() => navigate("/login", { replace: true }), 50);
    }
  }

  return (
    <div data-testid="page-auth-callback" className="min-h-[60vh] grid place-items-center">
      <div className="text-center">
        <Loader2 className="mx-auto h-6 w-6 animate-spin text-zinc-700" />
        <p className="mt-3 text-sm text-zinc-600">Signing you in…</p>
      </div>
    </div>
  );
}
